/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Stat_ConnectInputs */

const es_home_intro_stat_connect = /** @type {(inputs: Home_Intro_Stat_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para conectar tu primera fuente`)
};

const en_home_intro_stat_connect = /** @type {(inputs: Home_Intro_Stat_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to connect your first source`)
};

/**
* | output |
* | --- |
* | "to connect your first source" |
*
* @param {Home_Intro_Stat_ConnectInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_stat_connect = /** @type {((inputs?: Home_Intro_Stat_ConnectInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Stat_ConnectInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_stat_connect(inputs)
	return en_home_intro_stat_connect(inputs)
});
export { home_intro_stat_connect as "home.intro.stat_connect" }